// extracted by mini-css-extract-plugin
module.exports = {"group":"ConceptGroup-module__group__3mC2y","grow-width":"ConceptGroup-module__grow-width__3k493"};